module.exports = "/v2/pages/dashboard/dist/9826b2444f19595227c5628d07242b7b.svg";